import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import * as auth from '../../redux/AuthRedux';
// import axios from 'axios';
// import { RootState } from '../../../setup';
// import { IAuthState } from '../../redux/AuthRedux';
// import { BASE_URL } from '../../../config/environmentConfig';
//
// const LOGOUT_URL = `${BASE_URL.IDENTITY}/identity/sign-out`;

export function Logout(): JSX.Element {
	const dispatch = useDispatch();
	// const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	useEffect(() => {
		console.log('logout---009');
		dispatch(auth.actions.logout());
		// if (authUser.userData && authUser.userData.userId && authUser.idToken) {
		// 	axios.post(LOGOUT_URL, { userId: authUser.userData.userId, token: authUser.idToken })
		// 		.finally(() => {
		// 			dispatch(auth.actions.logout());
		// 			document.location.reload();
		// 		})
		// } else {
		// 	dispatch(auth.actions.logout());
		// 	document.location.reload();
		// }
	}, [dispatch]);

	return (
		<Routes>
			<Route path='*' element={<Navigate to="/auth/login"/>} />
		</Routes>
	);
}
